
import { Component, Vue } from 'vue-property-decorator'
@Component
export default class extends Vue {
  mounted() {
    document.title = '微信登录'
  }
}
